import MasterData from './masterData';

export const specialtiesList: Array<MasterData> = 
[
    {
        'type': 1,
        'value': 'Acupuncture',
        'description': 'Acupuncture'
    },
    {
        'type': 1,
        'value': 'Allergy and Immunology',
        'description': 'Allergy and Immunology'
    },
    {
        'type': 1,
        'value': 'Anatomic/Clinical Pathology',
        'description': 'Anatomic/Clinical Pathology'
    },
    {
        'type': 1,
        'value': 'Anesthesiology',
        'description': 'Anesthesiology'
    },
    {
        'type': 1,
        'value': 'Cardiology (Disease)',
        'description': 'Cardiology (Disease)'
    },
    {
        'type': 1,
        'value': 'Cardiology (Interventional)',
        'description': 'Cardiology (Interventional)'
    },
    {
        'type': 1,
        'value': 'Child and Adolescent Psychiatry',
        'description': 'Child and Adolescent Psychiatry'
    },
    {
        'type': 1,
        'value': 'Chiropractic',
        'description': 'Chiropractic'
    },
    {
        'type': 1,
        'value': 'Colon and Rectal Surgery',
        'description': 'Colon and Rectal Surgery'
    },
    {
        'type': 1,
        'value': 'Complementary Alternative Medicine',
        'description': 'Complementary Alternative Medicine'
    },
    {
        'type': 1,
        'value': 'Dentistry',
        'description': 'Dentistry'
    },
    {
        'type': 1,
        'value': 'Dermatology',
        'description': 'Dermatology'
    },
    {
        'type': 1,
        'value': 'Diagnostic Radiology',
        'description': 'Diagnostic Radiology'
    },
    {
        'type': 1,
        'value': 'Emergency Medicine',
        'description': 'Emergency Medicine'
    },
    {
        'type': 1,
        'value': 'Endocrinology',
        'description': 'Endocrinology'
    },
    {
        'type': 1,
        'value': 'Family Medicine',
        'description': 'Family Medicine'
    },
    {
        'type': 1,
        'value': 'Gastroenterology',
        'description': 'Gastroenterology'
    },
    {
        'type': 1,
        'value': 'General Practice',
        'description': 'General Practice'
    },
    {
        'type': 1,
        'value': 'General Surgery',
        'description': 'General Surgery'
    },
    {
        'type': 1,
        'value': 'Hematology',
        'description': 'Hematology'
    },
    {
        'type': 1,
        'value': 'Hepatology',
        'description': 'Hepatology'
    },
    {
        'type': 1,
        'value': 'Hospitalist',
        'description': 'Hospitalist'
    },
    {
        'type': 1,
        'value': 'Infectious Disease',
        'description': 'Infectious Disease'
    },
    {
        'type': 1,
        'value': 'Internal Medicine',
        'description': 'Internal Medicine'
    },
    {
        'type': 1,
        'value': 'Medical Genetics',
        'description': 'Medical Genetics'
    },
    {
        'type': 1,
        'value': 'Naturopathy',
        'description': 'Naturopathy'
    },
    {
        'type': 1,
        'value': 'Nephrology',
        'description': 'Nephrology'
    },
    {
        'type': 1,
        'value': 'Neurological Surgery',
        'description': 'Neurological Surgery'
    },
    {
        'type': 1,
        'value': 'Neurology',
        'description': 'Neurology'
    },
    {
        'type': 1,
        'value': 'Nuclear Medicine',
        'description': 'Nuclear Medicine'
    },
    {
        'type': 1,
        'value': 'Nutritionist',
        'description': 'Nutritionist'
    },
    {
        'type': 1,
        'value': 'Obstetrics and Gynecology (OBGYN)',
        'description': 'Obstetrics and Gynecology (OBGYN)'
    },
    {
        'type': 1,
        'value': 'Occupational Medicine',
        'description': 'Occupational Medicine'
    },
    {
        'type': 1,
        'value': 'Oncology',
        'description': 'Oncology'
    },
    {
        'type': 1,
        'value': 'Ophthalmology',
        'description': 'Ophthalmology'
    },
    {
        'type': 1,
        'value': 'Optometry',
        'description': 'Optometry'
    },
    {
        'type': 1,
        'value': 'Orthopedic Surgery',
        'description': 'Orthopedic Surgery'
    },
    {
        'type': 1,
        'value': 'Osteopathic Medicine',
        'description': 'Osteopathic Medicine'
    },
    {
        'type': 1,
        'value': 'Otolaryngology',
        'description': 'Otolaryngology'
    },
    {
        'type': 1,
        'value': 'Pain Medicine',
        'description': 'Pain Medicine'
    },
    {
        'type': 1,
        'value': 'Pediatrics',
        'description': 'Pediatrics'
    },
    {
        'type': 1,
        'value': 'Physical Medicine and Rehabilitation',
        'description': 'Physical Medicine and Rehabilitation'
    },
    {
        'type': 1,
        'value': 'Physical Therapy',
        'description': 'Physical Therapy'
    },
    {
        'type': 1,
        'value': 'Plastic and Reconstructive Surgery',
        'description': 'Plastic and Reconstructive Surgery'
    },
    {
        'type': 1,
        'value': 'Podiatry',
        'description': 'Podiatry'
    },
    {
        'type': 1,
        'value': 'Psychiatry',
        'description': 'Psychiatry'
    },
    {
        'type': 1,
        'value': 'Psychology',
        'description': 'Psychology'
    },
    {
        'type': 1,
        'value': 'Pulmonary Disease',
        'description': 'Pulmonary Disease'
    },
    {
        'type': 1,
        'value': 'Radiology',
        'description': 'Radiology'
    },
    {
        'type': 1,
        'value': 'Rheumatology',
        'description': 'Rheumatology'
    },
    {
        'type': 1,
        'value': 'Thoracic Surgery',
        'description': 'Thoracic Surgery'
    },
    {
        'type': 1,
        'value': 'Transplant Surgery',
        'description': 'Transplant Surgery'
    },
    {
        'type': 1,
        'value': 'Urology',
        'description': 'Urology'
    }
];


// WEBPACK FOOTER //
// ./src/models/specialtyList.ts